import {useEffect, useRef} from 'react'

import {PartyLedgerEditModalFormWrapper} from './PartyLedgerEditModalFormWrapper'
import {PartyLedgerEditModalHeader} from './PartyLedgerEditModalHeader'
import {useListView} from '../core/ListViewProvider'

const PartyLedgerEditModal = () => {
  const modalRef = useRef<any>()
  const {setItemIdForUpdate} = useListView()

  useEffect(() => {
    const checkIfClickedOutside = (e: any) => {
      if (modalRef.current && !modalRef.current.contains(e.target)) {
        setItemIdForUpdate(undefined)
      }
    }

    document.addEventListener('mousedown', checkIfClickedOutside)

    return () => {
      // Cleanup the event listener
      document.removeEventListener('mousedown', checkIfClickedOutside)
    }
  })
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_PartyLedger'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog mw-850px' ref={modalRef}>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <PartyLedgerEditModalHeader />
            {/* begin::Modal body */}
            <div className='modal-body mt-5 scroll-y p-0 px-10'>
              <PartyLedgerEditModalFormWrapper />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {PartyLedgerEditModal}
